/**
 * Abbildung der Staende und Sichtbarkeiten auf Gestaltungsentscheidungen.
 *
 * Wie bei den Tickets steht die Zuordnung an einer Stelle: Sie gilt in der
 * Trefferliste, in der Einzelansicht und in den Vorschlaegen bei der
 * Ticketerfassung gleichermassen.
 */

import type { BadgeTone } from '../../components/Badge';
import type { ArticleStatus, ArticleVisibility } from './api';

export function toneForStatus(status: ArticleStatus): BadgeTone {
  switch (status) {
    case 'draft':
      return 'neutral';
    case 'review':
      return 'warning';
    case 'published':
      return 'success';
    case 'archived':
      return 'neutral';
  }
}

/**
 * Je weiter ein Artikel hinausreicht, desto auffaelliger die Kennzeichnung.
 *
 * `public` ist gelb und nicht gruen: Es ist kein Erfolg, sondern ein Hinweis
 * -- der Text steht im offenen Netz.
 */
export function toneForVisibility(visibility: ArticleVisibility): BadgeTone {
  switch (visibility) {
    case 'internal':
      return 'neutral';
    case 'portal':
      return 'info';
    case 'public':
      return 'warning';
  }
}

/** Die Staende in der Reihenfolge des Freigabelaufs, nicht alphabetisch. */
export const ARTICLE_STATUSES: readonly ArticleStatus[] = [
  'draft',
  'review',
  'published',
  'archived',
];

export const ARTICLE_VISIBILITIES: readonly ArticleVisibility[] = ['internal', 'portal', 'public'];
